export default `
Die Seite wurde leider nicht gefunden.
`;
